import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'an-placeholder-tile',
    templateUrl: './placeholder-tile.component.html',
    styleUrls: ['./placeholder-tile.component.scss'],
    standalone: false
})
export class PlaceholderComponent implements OnInit {
  @Input('vehicleCount')
  vehicleCount: number;
  constructor(public changeDetectorRef: ChangeDetectorRef) { }
  
  ngOnInit() {

  }
}
